import ConfigurationRoutes from "./ConfigurationRoutes";
export default ConfigurationRoutes;